import React from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import InputText from "../../../../components/modalComponents/InputText";
import InputCheckBox from "../../../../components/modalComponents/InputCheckBox";

const TableWebBody = ({
                          filas,
                          setFilas,
                          editarFila,
                          onSubmit,
                          cancelarSubmit,
                          activarInactivar
                      }) => {

    const handleOnChange = (e, id) => {
        let inputType = e.target.type;
        const newInputFields = filas.map(fila => {
            if (fila.IdTipoLicenciaCondicion == id){
                fila[e.target.name] = (inputType === "checkbox") ? e.target.checked : e.target.value?.value ?? e.target.value;
            }
            return fila;
        });
        setFilas(newInputFields);
    }

    return (
        <>
            <tbody className="listar-tbody">
            {filas.map((fila, i) => (
                <tr key={i}>

                    <td>
                        <InputText
                            colLabel={0}
                            isDisabled={!fila.Editable}
                            name="Descripcion"
                            value={fila.Descripcion}
                            onChange={(e)=>{handleOnChange(e,fila.IdTipoLicenciaCondicion )}}
                            isRequired={true}
                            direction={""}
                            hasValidationMessage={false}
                            placeholder={""}
                            title={fila.Descripcion}
                            not_d_flex={true}
                        />

                    </td>
                    <td>
                        <InputText
                            colLabel={0}
                            isDisabled={!fila.Editable}
                            name="Abreviatura"
                            value={fila.Abreviatura}
                            onChange={(e)=>{handleOnChange(e,fila.IdTipoLicenciaCondicion )}}
                            isRequired={true}
                            direction={""}
                            hasValidationMessage={false}
                            placeholder={""}
                            title={fila.Abreviatura}
                            not_d_flex={true}
                        />
                    </td>
                    <td>
                        <InputCheckBox
                            textInput={""}
                            isDisabled={!fila.Editable}
                            name="AlRegistrarLicencia_CampoMotivo_EsObligatorio"
                            value={fila.AlRegistrarLicencia_CampoMotivo_EsObligatorio}
                            onChange={(e)=>{handleOnChange(e,fila.IdTipoLicenciaCondicion )}}
                            direction={""}
                            inputCheckBoxClass={"custom-switch"}
                            id={fila.IdTipoLicenciaCondicion}
                        />
                    </td>

                    <td>
                        <InputCheckBox
                            textInput={""}
                            isDisabled={!fila.Editable}
                            name="AlRegistrarLicencia_Mostrar_CampoHorario"
                            value={fila.AlRegistrarLicencia_Mostrar_CampoHorario}
                            onChange={(e)=>{handleOnChange(e,fila.IdTipoLicenciaCondicion )}}
                            direction={""}
                            inputCheckBoxClass={"custom-switch"}
                            id={fila.IdTipoLicenciaCondicion}
                        />
                    </td>

                    <td>
                        <InputCheckBox
                            textInput={""}
                            isDisabled={!fila.Editable}
                            name="AlRegistrarLicencia_VisibleParaColaborador"
                            value={fila.AlRegistrarLicencia_VisibleParaColaborador}
                            onChange={(e)=>{handleOnChange(e,fila.IdTipoLicenciaCondicion )}}
                            direction={""}
                            inputCheckBoxClass={"custom-switch"}
                            id={fila.IdTipoLicenciaCondicion}
                        />
                    </td>

                    <td>
                        <div className="d-flex justify-content-start mt-2 ml-2">
                            {fila.Editable ?
                                <>
                                    <FontAwesomeIcon icon='save' size="lg" className="hand-pointer mr-3" title="Guardar" onClick={() => onSubmit(fila)}/>
                                    <FontAwesomeIcon icon='times' size="lg" className="hand-pointer" title="Cancelar" onClick={() => cancelarSubmit(fila.IdTipoLicenciaCondicion)}/>
                                </>
                                :<>
                                    <FontAwesomeIcon icon='edit' size="lg" className="hand-pointer mr-3" title="Editar configuración" onClick={() => editarFila(fila)}/>

                                    <FontAwesomeIcon
                                        icon={fila.EsActivo ? 'ban' : 'circle-notch'}
                                        title={fila.EsActivo  ? 'Inactivar' : 'Activar'}
                                        size='lg'
                                        onClick={()=>{activarInactivar(fila.IdTipoLicenciaCondicion)}}
                                    />
                                </>
                            }
                        </div>
                    </td>
                </tr>
            ))}
            </tbody>
        </>)
};

export default TableWebBody;